import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import DataTableRepository from '../Repositories/DataTableRepository'


class DataTableBloc {

    rowtableChannel = new Subject();
    inactiveChannel = new Subject();
    activeChannel = new Subject();
    syaratChannel = new Subject();
    monitoringChannel = new Subject();
    loadTahunChannel = new Subject();
    exportChannel = new Subject();
    repository = new DataTableRepository()

    constructor() {
        this.rowtableChannel.next({status: apiResponse.INITIAL})
        this.inactiveChannel.next({status: apiResponse.INITIAL})
        this.activeChannel.next({status: apiResponse.INITIAL})
    }

    fetchRowTable = async (query, cancelToken) => {
        this.rowtableChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchRowTable(query, cancelToken).then((result) => {
            this.rowtableChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.rowtableChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchInactive = async (query) => {
        this.inactiveChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchInactive(query).then((result) => {
            this.inactiveChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.inactiveChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchActive = async (query) => {
        this.activeChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchActive(query).then((result) => {
            this.activeChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.activeChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchSyarat = async (query) => {
        this.syaratChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchSyaratDokumen(query).then((result) => {
            this.syaratChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.syaratChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchMonitoring = async (query) => {
        this.monitoringChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchMonitoring(query).then((result) => {
            this.monitoringChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.monitoringChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchTahun = async (query) => {
        this.loadTahunChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchTahun(query).then((result) => {
            this.loadTahunChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.loadTahunChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchExport = async (query) => {
        this.exportChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchExport(query).then((result) => {
            this.exportChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.exportChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

   
}

export default DataTableBloc